import axios from 'axios';
import config from 'config';

export function queueMetric(metric: string): void {
  initMetricWorker();
  window.metrics!.worker.postMessage({
    path: config.metricsPath,
    metric: metric,
    version: window.version
  });
}

//Use when queue metric is experiencing too many issues
export async function recordMetric(
  metric: string,
  timeout: number
): Promise<void> {
  try {
    const resp = await axios.post(
      `${config.metricsPath}`,
      { metric },
      {
        headers: {
          'Content-Type': 'application/JSON',
          'X-Replicon-Application': `time-intelligence-web;v=${window.version}`
        },
        timeout: timeout
      }
    );

    if (resp.status !== 200) {
      console.error(JSON.stringify(resp));
    }
  } catch (e: unknown) {
    let level: 'error' | 'warn' = 'error';
    if (axios.isAxiosError(e) && e.response?.status === 405) {
      level = 'warn';
    }
    if (!JSON.stringify(e).includes(`timeout of ${timeout}ms exceeded`)) {
      console[level](JSON.stringify(e));
    }
  }
}

export function initMetricWorker(): void {
  if (!window.metrics?.worker) {
    window.metrics = {
      worker: new Worker(`${process.env.PUBLIC_URL}/metricsScript.js`)
    };
    window.metrics.worker!.onmessage = function (event) {
      const resp = event.data;
      if (!resp) {
        console.log('invalid response from metrics');
      }
    };
  }
}
